import { StrictMode } from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

document.documentElement.dataset.basePath = import.meta.env.BASE_URL;
const root = document.getElementById("root");
if (!root) throw new Error("COMMUNITY_SITE_ROOT_MISSING");
const app = <StrictMode><App /></StrictMode>;
const shouldHydrate = root.hasChildNodes() && root.dataset.noHydrate !== "true";
if (shouldHydrate) hydrateRoot(root, app);
else {
  root.replaceChildren();
  createRoot(root).render(app);
}
